import PoopUpSearch from "./PoopUpSearch";
import TopMenu from "./TopMenu";
import ContactExpert from "./ContactExpert";
import MainMenu from "./MainMenu";
import MobileMenu from "./MobileMenu";

/** Shared header shell — legacy MenuPopUp / DashboardMenu removed (replaced by MobileMenu). */
export default function PageChrome() {
  return (
    <>
      <PoopUpSearch />
      <TopMenu />
      <ContactExpert />
      <MainMenu />
      <MobileMenu />
    </>
  );
}
